import { createSelector } from 'reselect';

import { getListingChannelId } from '../products/helpers/channelHelpers';

const selectProducts = (state) => state.products;

const emptyEntities = {
  listings: {},
  listingVariants: {},
  assets: {
    listingAssets: {},
    listingVariantAssets: {},
    masterAssets: {},
    masterVariantAssets: {},
  },
};

export const selectProductsEntities = createSelector(
  selectProducts,
  (products) => products.entities || emptyEntities,
);

export const selectListingsByProductChannel = createSelector(
  selectProductsEntities,
  (entities) => {
    const index = {};

    Object.values(entities.listings || {}).forEach((listing) => {
      if (!listing?._id || !listing?.masterProductId) return;

      const channelId = getListingChannelId(listing);
      if (!channelId) return;

      if (!index[listing.masterProductId]) {
        index[listing.masterProductId] = {};
      }

      index[listing.masterProductId][channelId] = listing._id;
    });

    return index;
  },
);

export const selectListingVariantsByMasterVariant = createSelector(
  selectProductsEntities,
  (entities) => {
    const index = {};

    Object.values(entities.listingVariants || {}).forEach((listingVariant) => {
      if (!listingVariant?._id || !listingVariant?.masterVariantId) return;

      const channelId = getListingChannelId(listingVariant);
      if (!channelId) return;

      if (!index[listingVariant.masterVariantId]) {
        index[listingVariant.masterVariantId] = {};
      }

      index[listingVariant.masterVariantId][channelId] = listingVariant._id;
    });

    return index;
  },
);
